module.exports = __webpack_public_path__ + "static/swim_min-6a256b1cd6aa01a2fda5bd48fb1902e6.mp4";